<template>
  <div>
    <header class="maui-bar aui-bar aui-bar-nav">
      <router-link to="/supply">
        <a class="aui-pull-left aui-btn" href="javascript:void(0);" @click="backsupply">
          <span class="aui-iconfont aui-icon-left"></span>
        </a>
      </router-link>
      <div class="aui-title">供应信息</div>
      <a
        class="aui-pull-right aui-btn"
        href="javascript:void(0);"
        @click="supplyclose"
        v-if="showclose"
      >
        <span class="aui-iconfont aui-icon-close aui-icon-right"></span>
      </a>
    </header>
    <div class="maui-search aui-searchbar">
      <div class="aui-searchbar-input aui-border-radius">
        <form action="javascript:search();">
          <input
            type="search"
            placeholder="请输入搜索内容"
            id="search-input"
            v-model="kyeWord"
            @focus="seefocus"
          />
        </form>
        <div class="aui-searchbar-cancel" @click="onserach">
          <button type="submit" class="btn btn-default">
            <i class="aui-iconfont aui-icon-search"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="goodsTypes">
      <div class="item" @click="getList(0)">全部</div>
      <div class="item" @click="getList(1)">自营</div>
      <div class="item" @click="getList(2)">散货</div>
      <div class="item" @click="getList(3)">大货</div>
    </div>
    <!-- <div> <span style="color:red;font-size: 15px;">交易须知：假期期间（1.1-1.3），交易暂停，敬请谅解！</span> </div> -->
    <!-- area&screen -->
    <div class="area-wrapper">
      <router-link to="/areacountry" class="battery-area" v-if="supplyiscountryname">
        <div class="battery-supply-allcounty">
          {{supplyiscountryname}}
          <van-icon name="arrow-down" color="#a9a9a9" class="battery-supply-vanicon" />
        </div>
      </router-link>
      <!-- <router-link to="/areacountry" class="battery-area" v-else>
        <div class="battery-supply-allcounty">
          全国
          <van-icon name="arrow-down" color="#a9a9a9" class="battery-supply-vanicon" />
        </div>
      </router-link> -->

      <div @click="showPopup" class="battery-screen">
        筛选
        <van-icon name="filter-o" color="#a9a9a9" class="battery-supply-vanicon" />
      </div>
    </div>
    <!-- area&screen end-->
    <!-- 筛选 -->
    <van-popup v-model="show" position="right" :style="{ height: '100%' }">
      <div class="battery-screen-oneji" v-for="item in typelist" :key="item.key">
        <p>{{item.name}}</p>
        <div v-for="n in item.infoDTOList" :key="n.key">
          <div v-if="n.infoDTOList">
            <van-collapse v-model="activeNames">
              <van-collapse-item :name="n.id">
                <div slot="title">{{n.name}}</div>
                <div class="battery-screen-twoe">
                  <div v-for="i in n.infoDTOList" :key="i.key">
                    <span @click="onshowscreen(i.id)">{{i.name}}</span>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
        <div v-for="n in item.infoDTOList" :key="n.key" class="battery-screen-onejil">
          <div v-if="n.infoDTOList==undefined">
            <div @click="onshowscreen(n.id)">{{n.name}}</div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 筛选　end -->
    <router-view
	:type="type"
      :isscreenid.sync="screenid"
      :fetchcountry="isdatacountry"
      ref="searchsuppplyList"
      :childrouter="kyeWord"
      :minfkyeWord="issupplykyeWord"
    ></router-view>
  </div>
</template>
<script>
export default {
  name: "supply",
  props: ["isdatacountry", "iscountryname", "issupplykyeWord"],
  data() {
    return {
      //noDate: false,//这是一个判断是否加载的开关
      comments: [],
      showPage: 1,
      pageSize: 10,
      pageindex: 1,
      loading: false,
      finished: false,
      totalElements: "",
      kyeWord: "",
      showclose: false,
      show: false,
      activeNames: ["1"],
      typelist: "",
      supplyiscountryname: this.iscountryname,
      screenid: "",
	  type:0
    };
  },
  created() {
    // this.onLoada();
  },
  methods: {
    onshowscreen(id) {
      //console.log("suppply原始是：" + id);
      this.screenid = id;
      this.show = false;
      this.$router.push("/searchsuppplyList");
    },
    backsupply() {
      this.supplyiscountryname = "全国";
      // window.location.reload();
      this.$router.push("/suppplyList");
      // this.issupplykyeWord = "";
      // this.isdatacountry = "";
      // this.onLoada();
    },
    showPopup() {
      this.show = true;
    },
    onLoada() {
		let that = this;
      this.kyeWord = this.issupplykyeWord;
      console.log("这里是supplykyeWord " + this.issupplykyeWord);
      this.$axios
        .get(
          "/micro/permission_order-view/spgoods/read/query?pageNo=" +
            this.pageindex +
            "&pageSize=10&sort=0&goodsClassId=&kyeWord="+this.issupplykyeWord)
        .then(res => {
          debugger
          that.aloading = false;
          that.typelist = res.data.data;
          console.log(res.data.data);
        }); // 异步更新数据
      setTimeout(() => {
        // 异步滑动加载数据
        this.getMore(); // 加载状态结束
        this.loading = false;
        if (this.comments.length >= this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },
    getList(type) {
		this.type = type;
		
    },
    supplyclose() {
      this.$router.push("/supply");
      this.showclose = false;
      this.kyeWord = "";
    },
    seefocus() {
      this.showclose = true;
      this.$router.push("/supplysearch");
      console.log(this.active_search);
      this.$emit("isactive_search", this.active_search);
    },
    onserach() {
      if (this.kyeWord == "") {
        this.$message({
          message: "请输入您想搜索的内容！",
          type: "warning"
        });
      } else {
       // this.$emit("isSupplysearchkeyword", this.kyeWord);
        this.$router.push("/searchsuppplyList");
        
      }
    },
    getMore() {
      this.pageindex++;
    }
  }
};
</script>
 
<style scoped>

.goodsTypes{
  display: flex;
  flex-direction: row;
  gap: 10px;
  background-color: #f2f2f2;
  padding: 10px 5px;
  border-bottom: 5px solid #ffffff;
}
.goodsTypes .item{
  flex:1;
  background-color: #ffffff;
  border-radius: 13px;
  padding: 10px 20px;
  border: 1px solid #f2f2f2;
}

.battery-supply-allcounty {
  color: #2c3e50 !important;
}
.battery-screen-wapper {
  text-align: left;
}
.battery-screen-oneji > p {
  padding: 15px 20px;
  background: #f7f8fa;
  font-size: 16px;
  font-weight: bold;
  color: #222;
}
.battery-screen-oneji {
  width: 330px;
  text-align: left;
}
.battery-screen-twoji > p {
  padding: 15px 20px;
  background: #f7f8fa;
  font-size: 16px;
  font-weight: bold;
  color: #222;
}
.battery-screen-oneji .battery-screen-onejil {
  width: 30%;
  display: inline-block;
  text-align: center;
  margin: 5px 4px;
  font-size: 14px;
}
.battery-screen-twoe > div {
  width: 30%;
  display: inline-block;
  text-align: center;
  margin: 5px 4px;
  font-size: 14px;
}
.battery-supply-vanicon {
  font-size: 14px;
}
.area-wrapper {
  background: #f2f2f2;
  display: flex;
  padding: 8px 20px;
  border-bottom: 1px solid #f2f2f2;
}
.area-wrapper div {
  font-size: 14px;
}
.battery-screen {
  margin-left: auto;
}
.maui-bar.aui-bar-nav {
  background-color: #fff;
  color: #000;
  border-bottom: solid 0.1rem #efefef;
}
.aui-label-outlined.aui-label-danger,
.aui-label-outlined.aui-label-danger::after {
  border: solid 0.1rem #c9eee1;
  color: #3bb18a;
}
.aui-bar-nav .aui-btn .aui-iconfont {
  color: #000;
  font-weight: bold;
}
.aui-list {
  background: none;
}
.aui-list .aui-list-item-title.maui-news-tit {
  height: 2rem;
  line-height: 1rem;
  font-size: 0.75rem;
  color: #4f4f4f;
  overflow: hidden;
}
.aui-list .aui-list-item-text.maui-data {
  font-size: 0.65rem;
  margin: 0.2rem 0;
  color: #4f4f4f;
  justify-content: flex-end;
}

.aui-media-list .aui-list-item-inner.maui-supply-rightbox {
  border-bottom: solid 0.05rem #e0e0e0;
  padding: 0;
  margin: 0.7rem 0.75rem 0.7rem 0.2rem;
}
.aui-list .aui-list-item-media.maui-supply-media {
  width: 4.75rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list .aui-list-item-media.maui-supply-media img {
  width: 4rem;
  height: 5rem;
  border-radius: 0.2rem;
  border: solid 0.05rem #e0e0e0;
}

.aui-list .aui-list-item-text.maui-flex-start {
  justify-content: flex-start;
  margin-bottom: 0.2rem;
}
.maui-search.aui-searchbar {
  background-color: #fff;
}
.maui-search .aui-searchbar-input {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.maui-search .aui-searchbar-cancel {
}
.maui-search button {
  background: none;
  border: none;
  cursor: pointer;
}
.maui-goods-name {
  font-size: 0.75rem;
  color: #4f4f4f;
  margin-right: 0.5rem;
}
.maui-goods-class {
  font-size: 0.65rem;
  color: #1b8ae0;
  border: solid 0.05rem #;
}
.maui-goods-price {
  font-size: 0.65rem;
  color: #4f4f4f;
  margin-right: 0.5rem;
}
.maui-goods-l {
  font-size: 0.65rem;
  color: #1b8ae0;
  border: solid 0.05rem #1b8ae0;
  padding: 0 0.2rem;
  border-radius: 0.2rem;
}
.maui-goods-l2 {
  font-size: 0.65rem;
  color: #4f4f4f;
}
.aui-list .aui-list-item-text.maui-goods-thredbox i {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-goods-ad {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-goods-ad i {
  font-size: 0.6rem;
  color: #000;
  margin-right: 0.2rem;
}
.maui-goods-data {
  font-size: 0.6rem;
  color: #4f4f4f;
}

.aui-list .aui-list-item {
  background: none;
  border: none;
}

@media only screen and (max-width: 768px) {
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 480px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 49%;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 320px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 40%;
    font-size: 0.6rem;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 70%;
    font-size: 0.6rem;
  }
  .aui-input,
  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  textarea {
    font-size: 0.6rem;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/supply.vue